import React from "react"
import PropTypes from "prop-types"

import css from "./TextualButton.scss"

const TextualButton = ({ label, iconUrl, onClick, isDisabled, iconTitle = "icon" }) => {
    return (
        <button
            onClick={onClick}
            disabled={isDisabled}
            className={`${css.button} ${isDisabled ? css.disabled : ""} bodySemiBold flex alignCenter`}
        >
            {iconUrl && <img src={iconUrl} height={18} width={18} alt="" title={iconTitle} />}
            <span className={iconUrl ? css.marginLeft8 : ""}>{label}</span>
        </button>
    )
}

TextualButton.propTypes = {
    label: PropTypes.string.isRequired,
    iconUrl: PropTypes.string,
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    iconTitle: PropTypes.string,
}
export default TextualButton
